import { Grid } from '@mui/material';
import React, { useState } from 'react';
import Tableau from '../../../../components/tableau/Tableau';
import { AdministrateurBien } from '../../../../services/Api/swagger';
import { adbTableauHeader } from '../tableauHeader';

interface Props {
  page: number;
  nbrElementParPage: number;
  sortColumn: string;
  sortOrder: 'asc' | 'desc';
  searchCount: number;
  searchResults: AdministrateurBien[];

  onChangeNbrElementParPage(nbrElementParPage: number): void;

  onChangePage(page: number): void;

  onChangeTri(sortColumn: string, sortOrder: string): void;

  onConsulter(id: number): void;

  onDelete(id: number): void;

  onGenerer(id: number): void;
}

interface State {
  message: string; // Message  (Erreur / Information)
}

function ResultatsRecherche({
  nbrElementParPage,
  page,
  searchResults,
  searchCount,
  sortColumn,
  sortOrder,
  onChangeNbrElementParPage,
  onChangePage,
  onChangeTri,
  onConsulter,
  onDelete,
  onGenerer,
}: Props) {
  const [message, setMessage] = useState<string>('');

  const handleTrier = (event: React.MouseEvent, colonneId: string) => {
    event.preventDefault();
    let order = 'asc';
    if (sortOrder === 'asc') {
      order = 'desc';
    }
    onChangeTri(colonneId, order);
  };

  const handleChangerPage = (event: React.MouseEvent | null, page: number) => {
    event && event.preventDefault();
    onChangePage(page);
  };

  const handlechangerNbrResultatParPage = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    nbrElement: number,
  ) => {
    event && event.preventDefault();
    onChangeNbrElementParPage(nbrElement);
  };

  const handleConsulter = (id: number) => {
    onConsulter(id);
  };

  return (
    <Grid container>
      <Tableau
        isPaginer={true}
        page={page}
        type="adb"
        headerDonnees={adbTableauHeader}
        trierPar={sortColumn}
        ordreDeTrie={sortOrder}
        donneesTableau={searchResults}
        alerteEnCoursSuppression={false}
        nbrElementTotal={searchCount}
        nbrElementParPage={nbrElementParPage}
        onTrier={handleTrier}
        onConsulter={handleConsulter}
        onDelete={onDelete}
        onGenerer={onGenerer}
        onChangerPage={handleChangerPage}
        onChangerNbrResultatParPage={handlechangerNbrResultatParPage}
      />
    </Grid>
  );
}

export default ResultatsRecherche;
